import { cn } from "@/lib/utils/index";
import * as Tooltip from "@radix-ui/react-tooltip";

interface FetchTooltipProps {
  content: string | React.ReactNode;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
  maxWidth?: string;
  className?: string;
}

/**
 * Nowadays themed tooltip component.
 */
export const FetchTooltip = ({
  content,
  children,
  side = "top",
  align = "center",
  delayDuration = 300,
  className,
}: FetchTooltipProps) => {
  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            align={align}
            className={cn(
              "z-[100001] max-w-xs overflow-hidden rounded-md bg-gray-900 px-3 py-1.5 text-xs text-white font-bold shadow-md break-words",
              "data-[state=delayed-open]:data-[side=top]:animate-slideUpAndFade",
              "data-[state=delayed-open]:data-[side=right]:animate-slideRightAndFade",
              "data-[state=delayed-open]:data-[side=left]:animate-slideLeftAndFade",
              "data-[state=delayed-open]:data-[side=bottom]:animate-slideDownAndFade",
              "data-[state=closed]:animate-fadeOut",
              className
            )}
            sideOffset={4}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseUp={(e) => e.stopPropagation()}
          >
            {content}
            <Tooltip.Arrow className="fill-gray-900" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
